<template>
  <div class="w-full flex flex-col">
    <apollo-query v-if='!editing' :query='getToysQuery'
                  :variables='{from, size}'
                  fetch-policy='cache-and-network'
                  class="flex-none flex flex-row flex-wrap">
      <template v-slot='{ result: { loading, error, data }, isLoading }'>
        <div v-for='toy in (((data||{}).getToys||{}).items||[])'
             :key='toy.id'
             class='p-4 rounded m-4 shadow w-32 text-center border border-red-600'>
          <div @click='edit(toy)'
               class="cursor-pointer">
            <div class="font-semibold">{{toy.name}}</div>
            <div class="text-xs text-gray-500">{{toy.id}}</div>
          </div>
          <pbc-button @click='copyToy(toy)'>Copy</pbc-button>
        </div>

        <div class="p-4 rounded m-4 shadow w-32 text-center border border-red-600 cursor-pointer" @click='newToy'>
          <span class="font-semibold">New</span>
        </div>

      </template>
    </apollo-query>
    <toy-editor v-if='editing' class="grow"
                :toydata='toyToEdit' 
                :name='name'
                :description='description'
                :thumbnailImage='thumbnailImage'
                :is-public='isPublic'
                @back='editing = false'
                />
  </div>
</template>


<script>
import { cloneDeep } from 'lodash';
import { ApolloQuery } from 'vue-apollo';
import ToyData from '@/edit/tree/toydata.js';
import gql from 'graphql-tag';

const getToysQuery = gql(`
  query getToys($from: Int!, $size: Int!) {
    getToys(from: $from, size: $size) {
      items {
        id,
        name,
        description,
        thumbnailImage,
        public,
        toy
      }
    }
  }
`);
const EmptyToy = {
  name: 'Empty Toy',
  components:[],
  transforms:[],
  links:[],
  variables:[]
}
import ToyEditor from '@ui/organisms/ToyEditor.vue';
import uuid from 'uuid';
export default {
  props: {
  },
  data() {
    const toy = EmptyToy
    toy.id = uuid.v4();
    return {
      toy,
      editing:false,
      toyToEdit:{},
      name:'',
      description:'',
      thumbnailImage:'placeholder.png',
      isPublic:false,
      getToysQuery,
      from:0,
      size:100,
    }
  },
  components:{
    ToyEditor,
    ApolloQuery
  },
  mounted() {
  },
  methods:{
    newToy() {
      this.toyToEdit = cloneDeep(EmptyToy);
      this.toyToEdit.id = uuid.v4();
      this.name = '';
      this.description = '';
      this.thumbnailImage = 'placeholder.png'
      this.editing = true;
      this.isPublic = false;
    },

    copyToy(toy) {
      const lol = JSON.parse(toy.toy);
      const td = new ToyData(lol.layers, lol, true);
      this.toyToEdit = td.clone();
      //const toy
      this.toyToEdit.name = toy.name + " (Copy)";
      this.toyToEdit.id = uuid.v4();

      this.name = toy.name + " (Copy)";
      this.description = toy.description;
      this.thumbnailImage = toy.thumbnailImage;
      this.editing = true;
      this.isPublic = false;
    },
    edit(toy) {
      this.editing = true;
      this.toyToEdit = JSON.parse(toy.toy);
      this.name = toy.name;
      this.description = toy.description;
      this.thumbnailImage = toy.thumbnailImage;
      this.isPublic = toy.public;
    }
  },
  computed:{
  }
}
</script>
<style>

</style>
